export const width = {
  sm: '768px',
  md: '1024px',
  lg: '1440px',
} as const;
